import React, { useState, useEffect } from "react";
import Main from "./components/Main";
import { Button, Loader } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import "@aws-amplify/ui-react/styles.css";
import _ from "lodash";
import { Auth,Amplify } from "aws-amplify";

const AppRouter = () => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(localStorage.getItem("amplify-redirected-from-hosted-ui")==="true");
  useEffect(() => {
    async function getUser() {
      try {
        setUser(await Auth.currentAuthenticatedUser());
        // console.log({ user });
        const token = user.getSignInUserSession().getAccessToken();
        const idtoken = user.getSignInUserSession().getIdToken();
        // console.log({ token });
        // console.log({ idtoken });
        const credentials = await Auth.currentCredentials();
        // console.log({ credentials });
        setUser(user);
      } catch (err) {
        // console.log(err);
        // console.log(Amplify.Auth);
        if (err === "The user is not authenticated") {
          localStorage.clear();
          setIsLoading(false);
        } else {
          // console.log(err);
        }
      }
    }
    getUser();
  }, []);
  if (user) {
    // console.log({ user });
    return user && <Main user={user}> </Main>;
  } else {
    return (
      <div>
        <div hidden={isLoading}>
          <Button
            className="signin"
            onClick={() => {
              setIsLoading(false);
              Auth.federatedSignIn({ provider: "axapass" });
            }}
          >
            Sign In With PassAXA / OneAccount
          </Button>
        </div>
        <div hidden={isLoading}>
          <Button
            className="signin"
            onClick={() => {
              Auth.federatedSignIn();
            }}
          >
            Sign In With Cognito
          </Button>
        </div>
        <div hidden={!isLoading}>
          <Loader width="5rem" height="5rem" className="spinner" size="large" />
        </div>
      </div>
    );
  }
};

export default AppRouter;